module.exports = __webpack_public_path__ + "static/media/VMBSIPOIMG.f4453a7f.png";